import React from 'react';
import { useHistory } from 'react-router-dom';
import pathToRegexp from 'path-to-regexp';
import { useTranslation } from 'react-i18next';
import { Button, Popconfirm } from 'antd';
import { EditOutlined } from '@ant-design/icons';

import { Path } from '../../routes';

function ContentPreviewLink({ id }) {
  const { t } = useTranslation();
  const history = useHistory();

  const onClick = () => {
    history.push(pathToRegexp.compile(Path.PLAYLISTS)({ id }));
  };

  return (
    id && (
      <Popconfirm
        placement="top"
        title={t('leave-page')}
        cancelText={t('to-leave')}
        okText={t('yes')}
        onConfirm={onClick}
      >
        <Button className="content-preview-link" type="link">
          <div className="content-preview-link__icon">
            <EditOutlined />
          </div>
          <div className="content-preview-link__text">{t('edit')}</div>
        </Button>
      </Popconfirm>
    )
  );
}

export default ContentPreviewLink;
